import { formConstants } from '../../../../utils/constants/form-constants';

const UserTicketsDisplayFormData = (accountFormData, userAccountData) => {
    function buildUserTicketsFormData() {
        const {
            getTicketsCallbackUrl,
            downloadTicketPdfCallbackUrl,
            ssoUserTicketsFields,
            ssoDomain,
            ssoAccountHomePageFields,
        } = accountFormData;

        const {
            formTitle,
            noTicketsFoundText,
            printTicketModalText,
            printTicketDialogText,
            printTicketInputText,
            ticketIsPrintableText,
            ticketIsNotPrintableText,
            ticketIsAlreadyPrintedText,
            firstName,
            lastName,
        } = ssoUserTicketsFields;

        const {
            loadingErrorMessage,
            elapsedTimeLimit,
        } = ssoAccountHomePageFields;

        const formData = {};

        formData[formConstants.getTicketsCallbackUrl] = getTicketsCallbackUrl;
        formData[formConstants.downloadTicketPdfCallbackUrl] = downloadTicketPdfCallbackUrl;
        formData[formConstants.formTitle] = formTitle;
        formData.firstNameValue = userAccountData.firstName;
        formData.lastNameValue = userAccountData.lastName;
        formData[formConstants.noTicketsFoundText] = noTicketsFoundText;
        formData[formConstants.printTicketModalText] = printTicketModalText;
        formData[formConstants.printTicketDialogText] = printTicketDialogText;
        formData[formConstants.printTicketInputText] = printTicketInputText;
        formData[formConstants.ticketIsPrintableText] = ticketIsPrintableText;
        formData[formConstants.ticketIsNotPrintableText] = ticketIsNotPrintableText;
        formData[formConstants.ticketIsAlreadyPrintedText] = ticketIsAlreadyPrintedText;
        formData[formConstants.firstName] = firstName;
        formData[formConstants.lastName] = lastName;
        formData[formConstants.ssoDomain] = ssoDomain;

        formData[formConstants.loadingErrorMessage] = loadingErrorMessage;
        formData[formConstants.elapsedTimeLimit] = elapsedTimeLimit;

        return formData;
    }

    return buildUserTicketsFormData();
};

export default UserTicketsDisplayFormData;
